import { GLOBALS } from 'utils/generic/global-variables';
import { mountPoint } from 'utils/generic/route-manipulation';

export const SPORTSBOOK_VIEW_TYPES: Record<number, string> = {
  0: 'live',
  1: 'prematch',
  2: 'esport'
};

export const SEPARATED_WIDGETS = {
  get IS_SEPARATED_WIDGETS() {
    const pageType = window.fromNext
      ? GLOBALS?.currentPage?.type
      : GLOBALS.appConfigs?.pageParams?.pageType;

    return pageType !== 'pageBlank';
  },
  get IS_SEPARATED_ESPORT_WIDGETS() {
    const pageType = window.fromNext
      ? GLOBALS?.currentPage?.type
      : GLOBALS.appConfigs?.pageParams?.pageType;

    return pageType === 'pageESport';
  },
  get SEPARATED_WIDGETS_ROUTE() {
    return SEPARATED_WIDGETS.IS_SEPARATED_WIDGETS
      ? `${mountPoint(
          window.getPathname()
        )}/:sport?/:region?/:competition?/:game?`
      : undefined;
  }
};

export const GAME_TYPE_LIVE = 1;

export const DESKTOP_RIGHT_WRAPPER_Z_INDEX = 14;
export const INFINITE_SCROLL_ID = 'InfiniteScrollId';
export const MATCH_STREAMING_PLACEHOLDER_CONTAINER_ID =
  'matchStreamingPlaceHolderContainer';
export const ORIGINAL_MARKET_COUNT = 17;
